import { css } from '@emotion/react'

export const section = css`
  display: flex;
  justify-content: center;
`
